import React from 'react';
import CommonStoreContainer from './CommonStoreContainer';
import services from 'services';

const commonStoreContainer = new CommonStoreContainer(services);

export default commonStoreContainer;
